export const ROUTES = {
  // dashboard with drops and featured brands/collections
  STICKERS: '/',

  // not yet used
  MARKET: '/market',

  // workshop for creating/editing stickers
  WORKSHOP: '/workshop',

  // 2 tabs - my opened and unopened packs
  MY_COLLECTIONS: '/my-collections',

  // profile + tasks navigation tab
  EARN: '/earn',

  // wallet balance, deposit, withdrawal
  WALLET: '/wallet',

  // onboarding flow
  ONBOARDING: '/onboarding',

  // list of referred friends + invite link
  REFERRAL: '/referral',

  // list of all brands
  COLLECTIONS: '/collections',

  // list of all finished sales
  FINISHED_SALES: '/finished-sales',

  // detail of a collection
  DROP_COLLECTION: (id: string) => `/drop-collection/${id}`,

  // detail of a collection
  COLLECTION_DETAIL: (id: string) => `/collections/${id}`,

  // overview of xp needed to gain level
  LEVEL: '/level',

  // a drop finished, here the user gets to know what's inside the drop
  CLAIM_DROP: (id: string) => `/claim-drop/${id}`,

  // unwrapping goodies
  PACK_OPENING: (id: string) => `/pack-opening/${id}`,

  // drop detail
  JOIN_TO_GET_GOODIES: (id: string) => `/join-to-get-goodies/${id}`,

  // drop lock form
  DROP_LOCK_FORM: (id: string) => `/drop-lock-form/${id}`,

  // detail of an unwrapped pack
  PACK_DETAIL: (id: string) => `/pack-detail/${id}`,

  WORKSHOP_FORGE: '/workshop/forge',
  WORKSHOP_FORGE_RECIPE: (recipeId: string) => `/workshop/forge/recipe/${recipeId}`,
  WORKSHOP_FORGE_REQUEST: (requestId: string) => `/workshop/forge/request/${requestId}`,

  WORKSHOP_BURNING: '/workshop/burning',

  WORKSHOP_BURNING_DETAIL: (id: string) => `/workshop/burning/${id}`,

  WORKSHOP_BURNING_CONFIRM: (internalAssets: string[], externalAssets: string[], activityId: string) => {
    const internalParams = internalAssets.length > 0 ? `internal_assets=${internalAssets.join(',')}` : '';
    const externalParams = externalAssets.length > 0 ? `external_assets=${externalAssets.join(',')}` : '';
    const params = [internalParams, externalParams, `activityId=${activityId}`].filter(Boolean).join('&');
    return `/workshop/burning/confirm?${params}`;
  },

  WORKSHOP_STAKING: '/workshop/staking',

  WORKSHOP_STAKING_DETAIL: (id: string) => `/workshop/staking/${id}`,

  WORKSHOP_STAKING_CONFIRM: (internalAssets: string[], externalAssets: string[], activityId: string) => {
    const internalParams = internalAssets.length > 0 ? `internal_assets=${internalAssets.join(',')}` : '';
    const externalParams = externalAssets.length > 0 ? `external_assets=${externalAssets.join(',')}` : '';
    const params = [internalParams, externalParams, `activityId=${activityId}`].filter(Boolean).join('&');
    return `/workshop/staking/confirm?${params}`;
  },

  WORKSHOP_LEADERBOARD: '/workshop/leaderboard',

  WORKSHOP_LEADERBOARD_EVENT: (eventId: string) => `/workshop/leaderboard/${eventId}`,

  OAUTH_AUTHORIZE: '/oauth/authorize',
};
